import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../lib/utils';
import ResourceDirectory from './ResourceDirectory';

const ResourceCategoryPage = () => {
  const { categorySlug } = useParams();
  const [categories, setCategories] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/resources/categories`).then((r) => setCategories(r.data.categories || [])).catch(() => setCategories([]));
  }, []);

  if (categories === null) return <div className="min-h-screen pt-28 text-center text-gray-500">Loading…</div>;
  const cat = categories.find((c) => c.slug === categorySlug);
  if (!cat) return <Navigate to="/community/resources" replace />;

  const label = cat.label;
  return (
    <ResourceDirectory
      fixedCategory={categorySlug}
      seoTitle={`${label} Resources Near You | Community Resource Directory | I Need A Social Worker`}
      seoDesc={`Find trusted ${label.toLowerCase()} resources for your clients. Search by ZIP code and radius to surface local ${label.toLowerCase()} services plus nationwide help — curated for social workers.`}
    />
  );
};

export default ResourceCategoryPage;
